import BackendService from './BackendService';

async function getStockReport(data = {}, params) {
  return BackendService.post('/stock_reports/', data, {}, params);
}
async function getManualStockAdjustmentReport(data = {}, params) {
  return BackendService.post('/reports/manual-stock-adjustment/', data, {}, params);
}
async function getItemStockTransactions(item_id, data) {
  return BackendService.getData(`/items/${item_id}/stock_logs/`, {}, data);
}

async function getStockSummaryReport() {
  return BackendService.postData('/reports/stock-summary/');
}

async function getExpiringStockReport(data = {}, params) {
  return BackendService.post('/reports/expiring-item-stock/', data, {}, params);
}

async function getExpiredStockReport(data = {}, params) {
  return BackendService.post('/reports/expired-item-stock/', data, {}, params);
}

const StockReportService = {
  getStockReport,
  getManualStockAdjustmentReport,
  getItemStockTransactions,
  getStockSummaryReport,
  getExpiringStockReport,
  getExpiredStockReport,
};

export default StockReportService;
